import {gsap, Linear} from "gsap";
import {SmartComponent} from "smart-component-js";
import $ from "jquery";

class VisualParallaxComponent extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		let $el = $(this.element);
		var leftElemQuery = $el.data("left-elem-query");
		var rightElemQuery = $el.data("right-elem-query");
		var pinkBirdElemQuery = $el.data("pink-bird-elem-query");
		var yellowBirdElemQuery = $el.data("yellow-bird-elem-query");
		var detachElemQuery = $el.data("trigger-end-elem-query");
		this.init($el.find(leftElemQuery)[0], $el.find(rightElemQuery)[0], $(detachElemQuery), $el.find(pinkBirdElemQuery)[0], $el.find(yellowBirdElemQuery)[0]);
	}

	init(leftElement, rightElement, $detachElement, pinkBirdElemQuery, yellowBirdElemQuery) {
		gsap.set(leftElement, {x: -100, alpha: 0});
		gsap.set(rightElement, {x: 100, alpha: 0});
		gsap.set(yellowBirdElemQuery, {x: 100, alpha: 0});
		gsap.set(pinkBirdElemQuery, {x: -100, alpha: 0});

		setTimeout(() => {
			gsap.to(leftElement,  {x: 0, alpha: 1, ease: Linear.easeOut});
			gsap.to(rightElement, {x: 0, delay: 0.7, alpha: 1, ease: Linear.easeOut});
			gsap.to(yellowBirdElemQuery, {x: 0, delay: 0.3, alpha: 1, ease: Linear.easeOut});
			gsap.to(pinkBirdElemQuery, {x: 0, delay: 0.5, alpha: 1, ease: Linear.easeOut});
		}, 800);
		$(window).scroll(() => {
			if ($(window).width() > 767) {
				let currentScrollTop = $(window).scrollTop();
				if ($detachElement.length == 0 || $detachElement.offset().top > currentScrollTop)
					if (currentScrollTop > this.scrollTop) {
						gsap.to(leftElement,  {x: -25, alpha: 1, ease: Linear.easeOut});
						gsap.to(pinkBirdElemQuery,  {x: -25, alpha: 1, ease: Linear.easeOut});
					} else if (currentScrollTop < this.scrollTop) {
						gsap.to(leftElement, {x: 0, alpha: 1, ease: Linear.easeIn});
						gsap.to(pinkBirdElemQuery, {x: 0, alpha: 1, ease: Linear.easeIn});
						gsap.to(rightElement,  {x: 0, alpha: 1, ease: Linear.easeIn});
						gsap.to(yellowBirdElemQuery,  {x: 0, alpha: 1, ease: Linear.easeIn});
					}
				this.scrollTop = currentScrollTop;
			}
		});
	}

}


export default VisualParallaxComponent;



